export enum HomeView {
    Dashboard = "Dashboard",
    Users = "Users",
    Partners = "Partners",
    PartnersOverview = "Overview",
    PartnersRequests = "Requests",
    DataSources = "DataSources",
    Subscriptions = "Subscriptions",
    Auth = "Auth",
}

export enum LicenseType {
    Expired = 1,
    Paid = 2,
    Eval = 3,
    Unassigned = 4,
    Inactive = 5
}

export enum LandingPage {
    Default = 0,
    SharePoint = 1,
    Teams = 2,
    OneDrive = 3,
    Exchange = 4,
    Tess = 5
}

// Channel is the default and is represented as NULL in the database.
export enum DefaultChannelTabLocation {
    Channel = 0,
    Site = 1
}

export enum GraphType {
    Registrations = 1,
    UserActivity = 2
}

export enum MessageType {
    Confirmation,
    Success,
    Fail,
    Reason,
    YesNo
}

export enum PanelReturnType {
    Remove,
    Add,
    CreateTenant,
    AssignAdmin,
    RemoveAdmin,
    AddSearchField,
    RemoveSearchField,
    RemovePartnerUser,
    AddPartnerUser
}

export enum TenantListSections {
    AdvancedSearch,
    MetaData,
    Sites,
    Teams,
    ColorPicker
}

export enum DatasourceTypeEnum {
    DocubirdManagedSites = -1,
    SharePointDocumentTemplate = 0,
    SQLServer = 1,
    UniveCRM = 2,
    SimplicateOrganization = 3,
    SimplicateProject = 4,
    SimplicateEmployee = 5,
    SharePoint = 6,
    Internal = 7,
    Exchange = 8,
    KVK = 29,
}

export enum SubscriptionIntervalEnum {
    OnceOff = 0,
    Monthly = 1,
    Yearly = 2
}

export enum SubscriptionTierEnum {
    Trial = "Trial",
    Paid = "Paid"
}

export enum SubscriptionStatusEnum {
    Pending = "pending",
    Active = "active",
    Canceled = "canceled",
    Suspended = "suspended",
    Completed = "completed",
}

// Mirrors Docubird.Entities.Enums.SubscriptionProductEnum (server). Service add-ons have no
// seat semantics and must not be assignable to users.
export enum SubscriptionProductEnum {
    DocubirdProfessional = 1,
    DocubirdEssentials = 2,
    Service = 3,
}

export enum ScopeType {
    Graph = 0,
    SharePoint = 1,
    Approvals = 2
}